import { render, staticRenderFns } from "./ApprovalInProcess.vue?vue&type=template&id=9b0a85de&"
import script from "./ApprovalInProcess.vue?vue&type=script&lang=js&"
export * from "./ApprovalInProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports